import I18n from 'I18n';
import { useMemo } from 'react';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextArea from 'UIComponents/input/UITextArea';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalOperation } from '../../types';
import ApprovalErrorAlert from '../ApprovalErrorAlert';
import ApprovalRulesRadio from '../ApprovalRulesRadio';
import ApproverSelect from '../ApproverSelect';
import ApprovalModalMessage from './ApprovalModalMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { ApprovalModalMessageLabelHelpI18n, ApprovalModalMessageLabelI18n } from '../i18n/ApprovalModalMessageLabelI18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ApprovalModalBody(props) {
  const {
    alertContent,
    currentOperation,
    approverOwnerIds,
    errorSubCategory,
    isLoading,
    onChangeApprovers,
    onChangeApprovalRule,
    onChangeNote,
    note
  } = props;
  const approval = useApprovalContext();
  const noteIsRequired = useMemo(() => currentOperation === ApprovalOperation.RECALL || currentOperation === ApprovalOperation.REJECT, [currentOperation]);
  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      className: "align-center justify-center p-all-5",
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {})
    });
  }
  return /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "m-bottom-3",
      "data-test-id": "product-approvals-approval-modal-body",
      children: [alertContent && /*#__PURE__*/_jsx("div", {
        className: "m-bottom-3",
        children: alertContent
      }), errorSubCategory && /*#__PURE__*/_jsx(ApprovalErrorAlert, {
        errorSubCategory: errorSubCategory,
        approvalType: approval.meta.approvalType
      }), /*#__PURE__*/_jsx(ApprovalModalMessage, {})]
    }), currentOperation === ApprovalOperation.REQUEST && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ApproverSelect, {
        value: approverOwnerIds,
        onChange: onChangeApprovers
      }), /*#__PURE__*/_jsx(ApprovalRulesRadio, {
        approvalType: approval.meta.approvalType,
        onChangeApprovalRule: onChangeApprovalRule
      })]
    }), /*#__PURE__*/_jsx(UIFormControl, {
      help: /*#__PURE__*/_jsx(ApprovalModalMessageLabelHelpI18n, {
        currentOperation: currentOperation,
        approvalType: approval.meta.approvalType
      }),
      label: /*#__PURE__*/_jsx(ApprovalModalMessageLabelI18n, {
        currentOperation: currentOperation,
        approvalType: approval.meta.approvalType
      }),
      required: noteIsRequired,
      children: /*#__PURE__*/_jsx(UITextArea, {
        role: "textbox",
        "data-test-id": `product-approvals-approval-note-${currentOperation}`,
        rows: 4,
        placeholder: I18n.text(noteIsRequired ? 'productApprovals.approvalModalMessagePlaceholder' : 'productApprovals.approvalModalMessagePlaceholderOptional'),
        value: note,
        onChange: onChangeNote
      })
    })]
  });
}
export default ApprovalModalBody;